import { focusRing } from '@repo/studio-design-system/utilities'
import { CheckIcon } from '@repo/studio-design-system-ui-icons/general/check'
import * as CheckboxPrimitive from 'primitives/checkbox'
import * as React from 'react'
import { tw } from 'utils/classnames'

const uncheckedClasses = [
  'bg-theme_semantic_control_selection_unselected_background_color-default',
  'border-theme_semantic_control_selection_unselected_border_color-default',
  'hover:border-theme_semantic_control_selection_unselected_border_color-hover',
  'focus-visible:border-theme_semantic_control_selection_unselected_border_color-focus',
  'active:border-theme_semantic_control_selection_unselected_border_color-active',
  'disabled:border-theme_semantic_control_selection_unselected_border_color-disabled',
].join(' ')

const checkedClasses = [
  'data-[state=checked]:bg-theme_semantic_control_selection_selected_background_color-default',
  'data-[state=checked]:border-theme_semantic_control_selection_selected_border_color-default',
  'data-[state=checked]:text-theme_semantic_control_selection_selected_foreground_color-selected',
  'data-[state=checked]:hover:border-theme_semantic_control_selection_selected_border_color-hover',
  'data-[state=checked]:focus-visible:border-theme_semantic_control_selection_selected_border_color-focus',
  'data-[state=checked]:active:border-theme_semantic_control_selection_selected_border_color-active',
  'data-[state=checked]:disabled:bg-theme_semantic_control_selection_selected_background_color-disabled',
  'data-[state=checked]:disabled:border-theme_semantic_control_selection_selected_border_color-disabled',
  'data-[state=checked]:disabled:text-theme_semantic_control_selection_selected_foreground_color-disabled',
].join(' ')

/**
 * Indicator / Checkbox. Takes 20px in layout: a 16px box with Figma's 2px safe area around it.
 *
 * @figma https://www.figma.com/design/mKWuIdPpAnPyyQnGc1pbY5/Studio-DS---Core-Components?node-id=1678-10746
 */
export function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      {...props}
      className={tw(
        'peer m-0.5 flex size-4 shrink-0 items-center justify-center rounded border-[1.5px] outline-none disabled:cursor-not-allowed',
        focusRing,
        uncheckedClasses,
        checkedClasses,
        className,
      )}
    >
      <CheckboxPrimitive.Indicator asChild>
        {/* eslint-disable-next-line cf-web/require-icon-parent */}
        <CheckIcon className="size-4 shrink-0" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}
